/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { StyledDatePickerButton } from '#PRIVATE_StyledDatePickerButton';
import { UseMonthCellProps, useMonthCell } from './useMonthCell';

type PickedUseMonthCellProps = Pick<
  UseMonthCellProps,
  'isCurrent' | 'isFocusable' | 'isFocused' | 'isSelected' | 'month' | 'onAction' | 'onNavigation'
>;
type Props = PickedUseMonthCellProps;

/**
 * This component renders the individual month cell in the MonthsGridView.
 */
export const MonthCell = (props: Props) => {
  const { buttonProps } = useMonthCell(props);
  return <StyledDatePickerButton {...buttonProps} />;
};
